import { Button } from "@studyplus/boron-ui";
import { Field, Form, FormikBag, FormikProps, withFormik } from "formik";
import * as React from "react";
import ErrorText from "../../../../components/atoms/ErrorText/index";
import Textarea from "../../../../components/atoms/Textarea/index";
import FormikHelper from "../../../../helpers/FormikHelper";
import styles from "./styles.scss";
import validationSchema, {
  PROMPT_MAX_LENGTH,
  type StudentFollowPromptFormValues,
} from "./validationSchema";

interface ComponentProps {
  prompt: string;
  submitting: boolean;
  onSubmit: (values: StudentFollowPromptFormValues) => void;
}

type Props = ComponentProps & FormikProps<StudentFollowPromptFormValues>;

const maxLengthLabel = PROMPT_MAX_LENGTH.toLocaleString("ja-JP");

const StudentFollowPromptForm: React.FC<Props> = (props) => {
  const shouldRenderError = FormikHelper.shouldRenderError(props, "prompt");

  return (
    <>
      <div className={`${styles.card} ${styles.aboutCard}`}>
        <p className="text-xl font-bold text-black mb-2">
          プロンプト設定とは？
        </p>
        <p className="text-lg leading-[1.4] text-black">
          AIアシスタントサマリーは、学習時間や成績、面談記録などのデータをもとに、生徒の状況を自動で要約する機能です。
          <br />
          抽出する観点は校舎担当スタッフが教室ごとの指導方針に合わせて設定しており、運用しながらいつでも見直せます。
        </p>
      </div>
      <Form className={styles.card}>
        <div className="mb-2">
          <label
            htmlFor="student_follow_prompt__prompt"
            className="text-xl font-bold text-black"
          >
            プロンプト
          </label>
        </div>
        <p className="text-md leading-[1.5] text-gray-900 mb-1">
          AIに要約させたい内容や条件を入力してください。次回のサマリー生成から反映されます。（
          {maxLengthLabel}文字以内）
        </p>
        <Field
          id="student_follow_prompt__prompt"
          name="prompt"
          component={Textarea}
          placeholder="プロンプトを入力"
          rows="6"
        />
        {shouldRenderError && (
          <ErrorText className="mt-1">{props.errors.prompt}</ErrorText>
        )}
        <p className="text-md leading-[1.5] text-gray-900 mt-1">
          {props.values.prompt.length.toLocaleString("ja-JP")} /{" "}
          {maxLengthLabel} 文字
        </p>
        <div className="flex justify-end mt-4">
          <Button
            disabled={props.submitting || !props.isValid}
            type="submit"
            className={styles.submitButton}
          >
            登録
          </Button>
        </div>
      </Form>
    </>
  );
};

const mapPropsToValues = (
  props: ComponentProps,
): StudentFollowPromptFormValues => ({
  prompt: props.prompt,
});

const handleSubmit = (
  values: StudentFollowPromptFormValues,
  formikBag: FormikBag<ComponentProps, StudentFollowPromptFormValues>,
) => {
  if (formikBag.props.submitting) {
    return;
  }
  formikBag.props.onSubmit(values);
};

export default withFormik({
  mapPropsToValues,
  handleSubmit,
  validationSchema,
})(StudentFollowPromptForm);
